const getters = {
    canUploadFile(state) {
        return state.file && state.target.brandId && state.target.establishmentId && state.target.establishmentAddressId && Object.keys(state.validationResults).length === 0;
    }
};

export default getters;
